// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import { EncodedType } from "./encoded-type";

/**
 * Rich message fingerprint for correlation.
 */
export class MessageFingerprint implements flatbuffers.IUnpackableObject<MessageFingerprintT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): MessageFingerprint {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsMessageFingerprint(
    bb: flatbuffers.ByteBuffer,
    obj?: MessageFingerprint,
  ): MessageFingerprint {
    return (obj || new MessageFingerprint()).__init(
      bb.readInt32(bb.position()) + bb.position(),
      bb,
    );
  }

  static getSizePrefixedRootAsMessageFingerprint(
    bb: flatbuffers.ByteBuffer,
    obj?: MessageFingerprint,
  ): MessageFingerprint {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new MessageFingerprint()).__init(
      bb.readInt32(bb.position()) + bb.position(),
      bb,
    );
  }

  payloadHash(): bigint {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset ? this.bb!.readUint64(this.bb_pos + offset) : 0n;
  }

  payloadSize(): number {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset ? this.bb!.readUint32(this.bb_pos + offset) : 0;
  }

  messageContentType(): number {
    const offset = this.bb!.__offset(this.bb_pos, 8);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : 0;
  }

  messageOrdinal(): number {
    const offset = this.bb!.__offset(this.bb_pos, 10);
    return offset ? this.bb!.readUint16(this.bb_pos + offset) : 0;
  }

  active(): boolean {
    const offset = this.bb!.__offset(this.bb_pos, 12);
    return offset ? !!this.bb!.readInt8(this.bb_pos + offset) : false;
  }

  encodedType(): EncodedType {
    const offset = this.bb!.__offset(this.bb_pos, 14);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : EncodedType.OneHot;
  }

  static startMessageFingerprint(builder: flatbuffers.Builder) {
    builder.startObject(6);
  }

  static addPayloadHash(builder: flatbuffers.Builder, payloadHash: bigint) {
    builder.addFieldInt64(0, payloadHash, 0n);
  }

  static addPayloadSize(builder: flatbuffers.Builder, payloadSize: number) {
    builder.addFieldInt32(1, payloadSize, 0);
  }

  static addMessageContentType(builder: flatbuffers.Builder, messageContentType: number) {
    builder.addFieldInt8(2, messageContentType, 0);
  }

  static addMessageOrdinal(builder: flatbuffers.Builder, messageOrdinal: number) {
    builder.addFieldInt16(3, messageOrdinal, 0);
  }

  static addActive(builder: flatbuffers.Builder, active: boolean) {
    builder.addFieldInt8(4, +active, +false);
  }

  static addEncodedType(builder: flatbuffers.Builder, encodedType: EncodedType) {
    builder.addFieldInt8(5, encodedType, EncodedType.OneHot);
  }

  static endMessageFingerprint(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    return offset;
  }

  static createMessageFingerprint(
    builder: flatbuffers.Builder,
    payloadHash: bigint,
    payloadSize: number,
    messageContentType: number,
    messageOrdinal: number,
    active: boolean,
    encodedType: EncodedType,
  ): flatbuffers.Offset {
    MessageFingerprint.startMessageFingerprint(builder);
    MessageFingerprint.addPayloadHash(builder, payloadHash);
    MessageFingerprint.addPayloadSize(builder, payloadSize);
    MessageFingerprint.addMessageContentType(builder, messageContentType);
    MessageFingerprint.addMessageOrdinal(builder, messageOrdinal);
    MessageFingerprint.addActive(builder, active);
    MessageFingerprint.addEncodedType(builder, encodedType);
    return MessageFingerprint.endMessageFingerprint(builder);
  }

  unpack(): MessageFingerprintT {
    return new MessageFingerprintT(
      this.payloadHash(),
      this.payloadSize(),
      this.messageContentType(),
      this.messageOrdinal(),
      this.active(),
      this.encodedType(),
    );
  }

  unpackTo(_o: MessageFingerprintT): void {
    _o.payloadHash = this.payloadHash();
    _o.payloadSize = this.payloadSize();
    _o.messageContentType = this.messageContentType();
    _o.messageOrdinal = this.messageOrdinal();
    _o.active = this.active();
    _o.encodedType = this.encodedType();
  }

  unpackFields(...fields: string[]): MessageFingerprintT {
    const t = new MessageFingerprintT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("payload_hash")) {
      t.payloadHash = this.payloadHash();
    }
    if (fieldSet.has("payload_size")) {
      t.payloadSize = this.payloadSize();
    }
    if (fieldSet.has("message_content_type")) {
      t.messageContentType = this.messageContentType();
    }
    if (fieldSet.has("message_ordinal")) {
      t.messageOrdinal = this.messageOrdinal();
    }
    if (fieldSet.has("active")) {
      t.active = this.active();
    }
    if (fieldSet.has("encoded_type")) {
      t.encodedType = this.encodedType();
    }
    return t;
  }
}

export class MessageFingerprintT implements flatbuffers.IGeneratedObject {
  constructor(
    public payloadHash: bigint = 0n,
    public payloadSize: number = 0,
    public messageContentType: number = 0,
    public messageOrdinal: number = 0,
    public active: boolean = false,
    public encodedType: EncodedType = EncodedType.OneHot,
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    return MessageFingerprint.createMessageFingerprint(
      builder,
      this.payloadHash,
      this.payloadSize,
      this.messageContentType,
      this.messageOrdinal,
      this.active,
      this.encodedType,
    );
  }

  clone(): MessageFingerprintT {
    const obj = new MessageFingerprintT();
    obj.payloadHash = this.payloadHash;
    obj.payloadSize = this.payloadSize;
    obj.messageContentType = this.messageContentType;
    obj.messageOrdinal = this.messageOrdinal;
    obj.active = this.active;
    obj.encodedType = this.encodedType;
    return obj;
  }

  equals(other: MessageFingerprintT): boolean {
    if (this.payloadHash !== other.payloadHash) return false;
    if (this.payloadSize !== other.payloadSize) return false;
    if (this.messageContentType !== other.messageContentType) return false;
    if (this.messageOrdinal !== other.messageOrdinal) return false;
    if (this.active !== other.active) return false;
    if (this.encodedType !== other.encodedType) return false;
    return true;
  }
}

export function verifyMessageFingerprint(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    verifier.checkScalarField(tablePos, 4, 8);
    verifier.checkScalarField(tablePos, 6, 4);
    verifier.checkScalarField(tablePos, 8, 1);
    verifier.checkScalarField(tablePos, 10, 2);
    verifier.checkScalarField(tablePos, 12, 1);
    verifier.checkScalarField(tablePos, 14, 1);
  } finally {
    verifier.popDepth();
  }
}
